import { render, staticRenderFns } from "./Selectors.vue?vue&type=template&id=640e3f3b&scoped=true&"
import script from "./Selectors.vue?vue&type=script&lang=js&"
export * from "./Selectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640e3f3b",
  null
  
)

export default component.exports